// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var FirstName = function (x) {
    return x;
};
var tsBridgeFirstName = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("FirstName")("__brandFirstName"));
    }
};
var writeFirstName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showFirstName = Data_Show.showString;
var readFirstName = Simple_JSON.readString;
var ordFirstName = Data_Ord.ordString;
var newtypeFirstName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeFirstName = FirstName;
var eqFirstName = Data_Eq.eqString;
export {
    FirstName,
    makeFirstName,
    unwrap,
    newtypeFirstName,
    eqFirstName,
    ordFirstName,
    showFirstName,
    readFirstName,
    writeFirstName,
    tsBridgeFirstName
};
//# sourceMappingURL=index.js.map
